import { speakItalian, stopSpeaking } from './speak';

let currentAudio = null;

export async function speakWithLuna(text, onEnd, speed = 1.0) {
    try {
        currentAudio?.pause();
        const response = await fetch('/api/tts', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ text, language: localStorage.getItem('vozoly_target_language') || 'italian' }),
        });
        if (!response.ok) throw new Error('tts failed');
        const { audio } = await response.json();
        const player = new Audio(`data:audio/mpeg;base64,${audio}`);
        player.playbackRate = speed;
        if (onEnd) player.onended = onEnd;
        currentAudio = player;
        await player.play();
    } catch (err) {
        speakItalian(text, onEnd);
    }
}

export function stopLunaVoice() {
    currentAudio?.pause();
    currentAudio = null;
    stopSpeaking();
}